export default {
  // Chủ tài khoản từ chối duyệt
  CompanyDirectorReject: -2,
  /// Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  /// Chờ phê duyệt
  Saved: 0,
  /// Chờ kế toán trưởng phê duyệt
  WaitChiefAccountantApproval: 1,
  /// Chờ thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  /// Chủ tài khoản đã duyệt
  //bỏ trạng thái chủ tài khoản đã duyệt-bug 61380-htthoa 12.12.2023
  // CompanyDirectorApproved: 3,
  /// Chờ KBNN tiếp nhận hồ sơ
  WaitKBNNReceipt: 96,
  ///KBNN đang xử lí hồ sơ
  KBNNHandling: 97,
  /// Đã được KBNN duyệt
  KBNNChiefApprove: 98,
  /// KBNN từ chối tiếp nhận hồ sơ
  KBNNReject: 99,
  // Chủ tài khoản, KTT xóa hồ sơ
  CompanyRemoveFile: 100,
  // KBNN thông báo kết quả xử lý thanh toán
  KBNNInfoResult: 101,
};
